import { Component } from '@angular/core';
import { trackByIndex } from 'src/app/shared/utils/track-by.util';

interface AlertResponsePreviewScenario {
    title: string;
    description: string;
    href: string;
}

/**
 * TEMPORARY local-preview picker for DASH-3076. The five mockup states are
 * driven by the mock-token scaffolding in NotificationService, so this page
 * exists only to give each one its own button while the real backend
 * endpoints (DASH-3188 / DASH-3210 / DASH-3133) are unbuilt. Delete this
 * component and its route alongside that scaffolding once a real backend
 * exists to test against.
 */
@Component({
    selector: 'app-alert-response-preview',
    templateUrl: './alert-response-preview.component.html',
    styleUrls: ['./alert-response-preview.component.scss'],
    standalone: false,
})
export class AlertResponsePreviewComponent {
    readonly trackByIndex = trackByIndex;

    readonly scenarios: AlertResponsePreviewScenario[] = [
        {
            title: 'State 1 - opened from the SMS',
            description: 'Nothing recorded yet. The locate map is read-only.',
            href: '/alert-response/mock',
        },
        {
            title: 'State 2 - acknowledged',
            description: 'Response capture is open; the map is now the coverage control.',
            href: '/alert-response/mock-acked',
        },
        {
            title: 'State 3 - no basemap, before ack',
            description: 'The basemap failed to load. The acknowledgement is completely unaffected.',
            href: '/alert-response/mock?mapError=1',
        },
        {
            title: 'State 4 - coverage without the map',
            description: 'Acknowledged, and the node list is the coverage control instead of the map.',
            href: '/alert-response/mock-acked?mapError=1',
        },
        {
            title: 'State 5 - controls unavailable',
            description: 'Acknowledged, but the response section is absent, not disabled.',
            href: '/alert-response/mock-nocapture',
        },
    ];
}
